import { putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const DELETE_PROVIDER_REQUEST = 'DELETE_PROVIDER_REQUEST';
export const DELETE_PROVIDER_REQUEST_SUCCESS =
  'DELETE_PROVIDER_REQUEST_SUCCESS';
export const DELETE_PROVIDER_REQUEST_FAILURE =
  'DELETE_PROVIDER_REQUEST_FAILURE';

// Action Creators
export const fetchDeleteProviderRequest = () => ({
  type: DELETE_PROVIDER_REQUEST,
});

export const fetchDeleteProviderRequestSuccess = (data) => ({
  type: DELETE_PROVIDER_REQUEST_SUCCESS,
  payload: data,
});

export const fetchDeleteProviderRequestFailure = (error) => ({
  type: DELETE_PROVIDER_REQUEST_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteProviderRequestCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchDeleteProviderRequest(data, external));
    try {
      const response = await putMethodWithToken(
        url.updateRequestStatus + data?.param + '/',
        data?.payload,
        external?.latlng
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchDeleteProviderRequestSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchDeleteProviderRequestFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchDeleteProviderRequestFailure(error.message));
    }
  };
};
